import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../lib/auth";
import { errorText } from "../../lib/api";
import { Field } from "./Field";

export const AccountTab = () => {
  const { user, changePassword } = useAuth();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.next.length < 10) return setError("New password must be at least 10 characters.");
    if (f.next !== f.confirm) return setError("New passwords don't match.");
    setBusy(true);
    try {
      await changePassword(f.current, f.next);
      setF({ current: "", next: "", confirm: "" });
      toast.success("Password updated. Other sessions have been signed out.");
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="max-w-md space-y-4 rounded-2xl border border-white/10 bg-[#12141C] p-6" data-testid="change-password-form">
      <div>
        <h2 className="font-display text-3xl font-extrabold uppercase text-white">Change password</h2>
        <p className="text-sm text-zinc-400">{user?.email}</p>
      </div>
      <Field label="Current password"><input required type="password" autoComplete="current-password" data-testid="cp-current" className="admin-input" value={f.current} onChange={set("current")} /></Field>
      <Field label="New password (min. 10 characters)"><input required type="password" autoComplete="new-password" data-testid="cp-new" className="admin-input" value={f.next} onChange={set("next")} /></Field>
      <Field label="Confirm new password"><input required type="password" autoComplete="new-password" data-testid="cp-confirm" className="admin-input" value={f.confirm} onChange={set("confirm")} /></Field>
      {error && <p role="alert" data-testid="cp-error" className="text-sm text-red-400">{error}</p>}
      <button data-testid="cp-submit" disabled={busy} className="btn-primary w-full justify-center">{busy && <Loader2 size={15} className="animate-spin" />} Update Password</button>
    </form>
  );
};
